import BannerCarousel from './common/BannerCarousel.vue'

const components = {
  BannerCarousel
}

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name])
    })
  }
}
